<template>
  <div class="backdrop" :class="{ 'backdrop--visible': visible }"></div>
</template>

<script setup lang="ts">
export interface Props {
  visible: boolean;
}

defineProps<Props>();
</script>

<style scoped>
.backdrop {
  z-index: 1005;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;
}

.backdrop--visible {
  opacity: 100;
  visibility: visible;
}
</style>
